<template>
  <section class="pa-2">
    <v-card class="p-1">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Compliance Control</div>
        <div>
          <bread-crumb :bread-crumbs="['Suspicious Hold List']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-container class="p-0 m-4">
        <v-row>
          <v-col cols="12">
            <v-alert outlined type="warning" prominent border="left">
              Max Number of Beneficiaries added by Customer in Entire
              Application Till now is
              <h5 class="font-weight-bold d-inline">{{ limitNum }}</h5>
              and if you want increase this Number please update below,
            </v-alert>
          </v-col>
        </v-row>
        <v-form ref="form" v-model="valid" class="mt-2">
          <v-row>
            <v-col cols="12" md="2" lg="3">
              <v-text-field
                placeholder="Beneficiaries Max Limit"
                outlined
                v-model="updateLimitNum"
                dense
                required
                :rules="nameRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" lg="3" class="mt-1">
              <v-btn
                depressed
                small
                class="text-capitalize"
                color="primary "
                outlined
                @click="validate"
                :disabled="!valid"
                >Update</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </section>
</template>
<script>
import setupService from "@/services/SetupService/setupService.js";
import alerts from "@/mixins/alerts";
import beneficiaryService from "@/services/RemitteService/remitteService.js";
export default {
  mixins: [alerts],
  name: "Compilance Control",
  data() {
    return {
      valid: true,
      limitNum: null,
      updateLimitNum: null,
      nameRules: [
        (v) => !!v || "This Field is required",
        (v) => !isNaN(v) || "Only numbers are allowed",
        (v) =>
          v > this.limitNum ||
          `please update more than current value  ${this.limitNum} `,
      ],
    };
  },
  mounted() {
    this.getHighestBeneCount();
  },
  methods: {
    validate() {
      const valid = this.$refs.form.validate();
      console.log(valid);
      if (valid) {
        this.updateLimit();
      }
    },
    async updateLimit() {
      console.log(this.updateLimitNum);

      const data = {
        description: "Beneficiary Limit",
        id: 1712,
        user_type: "BOT",
        value: this.updateLimitNum,
        value_code: "1",
      };
      const response = await setupService.updateBeneficiaryLimit(data);

      try {
        if (response && response?.data) {
          this.updateLimitNum = response?.data?.data[0]?.value;
          this.showAlertSuccess("Updated Successfully");
        } else {
          this.showAlertError(`Update Failed`);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getHighestBeneCount() {
      const response = await beneficiaryService.getHighestBeneCount();
      console.log(response?.data?.data[0]);
      try {
        if (response && response?.data) {
          this.limitNum = response?.data?.data[0];
          this.updateLimitNum = this.limitNum;
          this.updateLimitNum = this.updateLimitNum + 1;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
